import { useState } from "react" 
import { useNavigate, useParams } from 'react-router-dom';
import "../assets/styles/kehadiran.css" 

const Kehadiran = () => {
  const [reason, setReason] = useState("") 
  const [attendance, setAttendance] = useState(null) 
  const [showPopup, setShowPopup] = useState(false) 
  const [popupMessage, setPopupMessage] = useState("") 
  const [isSubmitted, setIsSubmitted] = useState(false) // untuk mengunci input setelah submit

  const navigate = useNavigate();
  const { day } = useParams();

  const handleAttendanceSelect = (status) => {
    if (isSubmitted) return; // sudah submit, blok input ulang
  
    if (status === "Tidak Hadir" && reason.trim() === "") {
      setPopupMessage("Mohon isi alasan ketidakhadiran terlebih dahulu sebelum mengonfirmasi ketidakhadiran.");
      setShowPopup(true);
      return;
    }
  
    setAttendance(status);
    if (status === "Hadir") {
      setPopupMessage("Terima kasih telah mengonfirmasi kehadiran!");
    } else {
      setPopupMessage("Terima kasih telah mengonfirmasi ketidakhadiran!");
    }
    setShowPopup(true);
    setIsSubmitted(true); // kunci input setelah submit
  };
  
  
  const handleReasonChange = (e) => {
    setReason(e.target.value) 
  } 

  const closePopup = () => {
    setShowPopup(false) 
  } 

  return (
    <div className="attendance-container">
      <div className="background-overlay"></div>

      {/* Header */}
      <div className="header">
        <div className="back-arrow" onClick={() => navigate(`/menu/${day}`)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#CCA4CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className="header-title">Kehadiran</h1>
      </div>

      {/* Main Card */}
      <div className="attendance-card">
        <h2 className="question-title">Apakah kamu hadir day {day} ?</h2>

        <div className="divider"></div>

        <div className="reason-section">
          <label className="reason-label">Alasan:</label>
          <textarea
            className="reason-input"
            placeholder="Alasan tidak hadir...."
            value={reason}
            onChange={handleReasonChange}
          />
        </div>

        <div className="button-section">
          <button
            className={`attendance-btn present-btn ${attendance === "Hadir" ? "selected" : ""}`}
            onClick={() => handleAttendanceSelect("Hadir")}
          >
            Hadir
          </button>

          <button
            className={`attendance-btn absent-btn ${attendance === "Tidak Hadir" ? "selected" : ""}`}
            onClick={() => handleAttendanceSelect("Tidak Hadir")}
          >
            Tidak Hadir
          </button>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-card">
            <div>{popupMessage}</div>
            <button onClick={closePopup}>Tutup</button>
          </div>
        </div>
      )}
    </div>
  ) 
} 

export default Kehadiran 